import React, { 
    useEffect, 
    useContext, 
    useCallback, 
    useState, 
} from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import QuestionsModal from '../../QuestionsModal';

import ConfirmAction from '../ConfirmDelete/index';

import DenunceOptionsModal from '../../ConfirmModal/index';
import DescriptionOptionsModal from '../../ConfirmModal/index';

import TrashIcon from '../../../../assets/Icons/ModalPJ/trash.svg';
import CheckIcon from '../../../../assets/Icons/ModalDenunciations/check.svg';

import ApproveIcon from '../../../../assets/Icons/ModalDenunciations/approve.svg';
import GreenApproveIcon from '../../../../assets/Icons/ModalDenunciations/greenApprove.svg';

import Cross from '../../../../assets/Icons/cross.svg';
import WhiteTrash from '../../../../assets/Icons/whiteTrash.svg';

import MyContext from '../../../../contexts/_ModalData/modal';

import api from '../../../../services/api';

import {aproveDescriptionMessage, deleteDenunceMessage, deleteDescriptionMessage} from './constants';

import './styles.css';

export default ({show, setShow, changeStatus }) => {
    
    const[showModalDeleteDenunceConfirm, setShowModalDeleteDenunceConfirm] = useState(false);

    const[showModalDescriptionOptions, setShowModalDescriptionOptions] = useState(false);

    const[showModalQuestionary, setShowModalQuestionary] = useState(false);
    
    const[title, setTitle] =  useState('');
    const[text, setText] =  useState('');
    
    const[showProgress, setShowProgress] = useState(false);
    
    const[showConfirmAction, setShowConfirmAction] = useState(false);
    const[textConfirm, setTextConfirm] = useState('');

    const [description, setDescription] = useState('');
    const [answer, setAnswer] = useState('');

    const [denunId, setDenunId] = useState('');

    const { denunciations } = useContext(MyContext);

    function getAlertLevel(riskAverage) {
        if (riskAverage > 0.774) return 5;
        else if (riskAverage > 0.5424) return 4;
        else if (riskAverage > 0.274) return 3;
        else if (riskAverage > 0.024) return 2;
        else if (riskAverage === 0) return 0;
        else return 1;
    }

    const sendNotifications = useCallback( async(message, title, type, id) =>{
        await api.post('/admin/sendMessage', {
            message:message,
            title:title,
            type:type,
            uid: id,
        }, {
            headers: { 
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}` 
            }
        }).catch( () => {
            setShowConfirmAction(true);
            setTextConfirm('Erro ao enviar E-mail.');
            setShowProgress(false);//to disable the circular progress
        });
    }, []);

    const sendMessage = useCallback(async(email, id, message, hasToken) => {
        const data = {
            email:email,
            text: message,
            subject:'Notificação do Aplicativo de Segurança da Mulher',
        }

        await api.post('/admin/sendEmail', 
            data,
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                },
            }
        ).then( ( ) =>{ 
            if (hasToken) {
                console.log(hasToken);
                sendNotifications(
                    `Email: ${email}\n`+ message, 
                    `Você recebeu uma notificação!`, 
                    'user', 
                    id
                );
            }
        }).catch(()=>{
            setShowConfirmAction(true);
            setTextConfirm('Erro ao enviar Notificação!');
            setShowProgress(false);//to disable the circular progress
        });
    }, [sendNotifications]);

    const getUserData = useCallback(async(message) => {
        await api.get('/denunciations/getUser', 
        {
            params: {id: denunId},
            headers: {
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,   
            }
        },
        ).then((response) => {
            let hasToken = false;
            if (response.data.deviceToken != null || undefined) {
                hasToken = true;
            }
            sendMessage(response.data.email, response.data.user.firebaseUID, message, hasToken);
        }).catch(( ) => {
            setShowConfirmAction(true);
            setTextConfirm('Erro ao buscar informação do usuario.');
            setShowProgress(false);//to disable the circular progress
        });
    },[denunId, sendMessage]);

    const handleDeleteDescription = useCallback(async () => {
        if (description !== "") {
            setTitle('Excluir');
            setText('Deseja excluir esse comentário permanentemente?');
            setShowModalDescriptionOptions(true);
        }else{
            setShowConfirmAction(true);
            setTextConfirm('Não existe comentário a ser deletado.');
        }
    }, [description]);

    const deleteDescription = useCallback(async () => {
        await api.put(`/admin/deleteDescripton`,
        {denunId: denunId},
        {
            headers: {
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
            },
        }
        ).then( ( ) =>{
            getUserData(deleteDescriptionMessage);
            setShowModalDescriptionOptions(false);//closes the first modal
            setShowConfirmAction(true);//calls the confirmation modal
            setTextConfirm('Comentário deletado com sucesso!');//sets the confirmation modal message
            changeStatus();//makes another api call
            setShow(false);//closes the main modal
            setShowProgress(false);//to disable the circular progress

        }).catch( ( ) =>{
            setShowModalDescriptionOptions(false); //closes the first modal
            setShowConfirmAction(true);
            setTextConfirm('Erro ao excluir comentário.');
            setShowProgress(false);//to disable the circular progress
        });
    }, [changeStatus, denunId, getUserData, setShow]);

    const handleDeleteDenunce = useCallback(async () => {
        setTitle('Excluir');
        setText('Deseja excluir essa denuncia permanentemente?');
        setShowModalDeleteDenunceConfirm(true);
    }, []);

    const deleteDenunce = useCallback( async () => {
        await api.delete(`/admin/deleteDenunciation`,
        {
            headers: {
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
            },
            data: {
                denunciationId: denunciations._id
            }
        }
        ).then( () =>{
            getUserData(deleteDenunceMessage);
            setShowModalDeleteDenunceConfirm(false);//closes the first modal
            setShowConfirmAction(true);//calls the confirmation modal
            setTextConfirm('Denuncia deletada com sucesso!');//sets the confirmation modal message
            changeStatus();//makes another api call
            setShow(false);//closes the main modal
            setShowProgress(false);//to disable the circular progress
        }).catch( () =>{
            setShowModalDeleteDenunceConfirm(false); //closes the first modal
            setShowConfirmAction(true);
            setTextConfirm('Erro ao excluir denuncia.');
            setShowProgress(false);//to disable the circular progress
        });
    }, [changeStatus, denunciations._id, getUserData, setShow]);

    const handleQuestionary = useCallback(() => {
        setShowModalQuestionary(true);
    }, []);

    const handleDescriptionApproval = useCallback(async() => {
        if (description !==  "") {
            setTitle('Aprovar');
            setText('Deseja Aprovar esse comentário permanentemente?');
            setShowModalDescriptionOptions(true);
        }else{
            setShowConfirmAction(true);
            setTextConfirm('Não existe comentário a ser aprovado.');
        }
    }, [description]);

    const approveDescription = useCallback(async() => {
        await api.put(`/admin/acceptDenuniation`,
            {denunId: denunciations._id}, {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,   
                }
            }
        ).then( ( ) => {
            getUserData(aproveDescriptionMessage);
            // console.log(response, 'response');
            setShowModalDescriptionOptions(false);//closes the first modal
            setShowConfirmAction(true);//calls the confirmation modal
            setTextConfirm('Comentário aprovado com sucesso!');//sets the confirmation modal message
            changeStatus();//makes another api call
            setShow(false);//closes the main modal
            setShowProgress(false);//to disable the circular progress

        }).catch( (error) =>{
            console.log(error, 'errodeletedenunce');
            setShowModalDescriptionOptions(false); //closes the first modal
            setShowConfirmAction(true);
            setTextConfirm('Erro ao aprovar comentário.');
            setShowProgress(false);//to disable the circular progress
        });
    }, [changeStatus, denunciations._id, getUserData, setShow]);

    useEffect(() => {
        setDenunId(denunciations._id);
        if (denunciations.description !== undefined || null || '') {
            setDescription(denunciations.description);
            if (denunciations.answers !== undefined || null || '') {
                setAnswer(denunciations.answers.answer);
            }
        }
        console.log(denunciations, 'denunOnModal');
    }, [answer, denunciations]);

    return(
        <div>
            <Dialog
                open={show} 
                aria-labelledby="draggable-dialog-title" 
                maxWidth='md'
                onClose={()=>setShow(false)}
            >
                <DialogContent>
                    <div className='modal-denun'>
                        <div>
                            <img src={Cross} alt="" onClick={()=>setShow(false)} className='cross-modal'/>
                        </div>
                        <h2 className='modal-pj-title'>Dados da denúncia</h2>

                        <div className='modal-denun-info'>
                            <p className='modal-header-description mgrtop1'>Nome do local: 
                                <p id='nome-dados' className='modal-header-description des-color'> {denunciations.title} </p>
                            </p>
                            {denunciations.users !== undefined ?
                                    <p className='modal-header-description mgrtop1'>Nome do denunciante: 
                                        <p id='email-dados' className='modal-header-description des-color'>{denunciations.users}</p>
                                    </p>
                                :
                                    null
                            }
                            <p className='modal-header-description mgrtop1'>Grau de risco: 
                                <p id='cpf-dados' className='modal-header-description des-color'>  
                                    {{
                                        1: ' Leve',
                                        2: ' Moderado',
                                        3: ' Grave',
                                        4: ' Muito grave',
                                        5: ' Máximo',
                                    }[getAlertLevel(denunciations.risk)]}
                                </p>
                            </p>
                        </div>

                        <h2 className='modal-pj-title'>Comentário</h2>
                        
                        <div className='modal-denun-denunciation'>

                            <div id='card-comentario-resposta' className='modal-content-card' >
                                <div className='modal-pf-card'>
                                    <p className = 'modal-content-comment'>
                                        { description !== '' ? 
                                            description   
                                            : 
                                            'Essa denúncia não possui comentário.'
                                        }
        
                                    </p>
                                    { description !== '' ? 
                                        <img src={WhiteTrash} alt="" className='modal-pf-trash' onClick={handleDeleteDescription}/>
                                    : 
                                        null
                                    }

                                </div>
                                { description !== '' ? 
                                    <>
                                        {
                                            answer !== '' ?
                                                <p className = 'modal-card-awnser'>
                                                    {answer}
                                                </p> 
                                            : null
                                        }  
                                    </>
                                    : 
                                    null
                                }      
                            </div>

                        </div>

                        <hr/>

                        <div className='modal-pj-buttons'>

                            <div 
                                id='questionario-button' 
                                className='modal-pj-buttons-combo-denun darkclr'
                                onClick={handleQuestionary}  
                            >
                                <img src={CheckIcon} alt=""/>
                                <p>Ver questionário</p>
                            </div>
                            { description !== '' ? 
                                <>
                                    {!denunciations.status ? 
                                            <div id='aprovar-button-denuncia' className='modal-pj-buttons-combo-denun darkclr' onClick={handleDescriptionApproval}>
                                                <img src={ApproveIcon} alt=""/>
                                                <p>Aprovar comentário</p>
                                            </div>
                                        :
                                            <div id='aprovar-button-denuncia-green' className='modal-pj-buttons-combo-denun greenclr' >
                                                <img 
                                                    src={GreenApproveIcon}
                                                    style={
                                                        {
                                                            size: 50,
                                                            left: 15,
                                                            marginLeft: 25,
                                                            alignItems: 'center', 
                                                            alignContent: 'center', 
                                                        }
                                                    }
                                                    alt=""
                                                />
                                                <p>Comentário aprovado </p>
                                            </div>
                                    }
                                </>
                            : null}

                            <div id='excluir-button' className='modal-pj-buttons-combo-denun clrDenun' onClick={handleDeleteDenunce}>
                                <img src={TrashIcon} alt='Deletar Denuncia'/>
                                <p>Excluir denúncia</p>
                            </div>
                            
                        </div>
                    </div>
                </DialogContent>
            </Dialog>

            <DenunceOptionsModal 
                showModal={showModalDeleteDenunceConfirm}
                decline={setShowModalDeleteDenunceConfirm}
                
                delete={deleteDenunce}
                
                title={title}
                text={text}
                
                showProgress={showProgress}
                setShowProgress={setShowProgress}
            />

            <DescriptionOptionsModal
                showModal={showModalDescriptionOptions}
                
                approval={approveDescription}
                decline={setShowModalDescriptionOptions}
                
                delete={deleteDescription}
                
                title={title}
                text={text}
                
                showProgress={showProgress}
                setShowProgress={setShowProgress}


            />

            <QuestionsModal 
                showModal={showModalQuestionary}
                decline={setShowModalQuestionary}

                title={'Questionario'}
            
            />

            <ConfirmAction // confirms the success of a action
                showModal={showConfirmAction}
                setShow={setShowConfirmAction}
                text={textConfirm}
            />


        </div>
    )
}